import {
  type IMessageAdapter,
  type IMessageAdapterOptions
} from "@package/shared/util/message";
import { ElMessage } from "element-plus";

export class MessageAdapter implements IMessageAdapter {
  info(text: string, opt?: IMessageAdapterOptions): void {
    ElMessage.info({message: text, duration: opt?.dur});
  }

  success(text: string, opt?: IMessageAdapterOptions): void {
    ElMessage.success({message: text, duration: opt?.dur});
  }

  warn(text: string, opt?: IMessageAdapterOptions): void {
    ElMessage.warning({message: text, duration: opt?.dur});
  }

  error(text: string, opt?: IMessageAdapterOptions): void {
    ElMessage.error({message: text, duration: opt?.dur});
  }

  clear(): IMessageAdapter {
    ElMessage.closeAll();
    return this;
  }
}
